export default __webpack_public_path__ + "static/media/Documentos-afiliacion-banco-pichincha.9eb26b79.pdf";